import { render, staticRenderFns } from "./SafetySuppliesApply.vue?vue&type=template&id=6c6cc45d&scoped=true&"
import script from "./SafetySuppliesApply.vue?vue&type=script&lang=js&"
export * from "./SafetySuppliesApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6cc45d",
  null
  
)

export default component.exports